

export class MediauploadForm {
  public image: String;
  public path: string;
  public fileName: string;

  constructor(mediaupload: any) {
    this.image = mediaupload.imageName || '';
    this.path = mediaupload.path || '';
    this.fileName = mediaupload.fileName || '';
  }
}
